import { render, staticRenderFns } from "./introduceDetail2.vue?vue&type=template&id=d7506fe0&scoped=true&lang=pug&"
import script from "./introduceDetail2.vue?vue&type=script&lang=js&"
export * from "./introduceDetail2.vue?vue&type=script&lang=js&"
import style0 from "./introduceDetail2.vue?vue&type=style&index=0&id=d7506fe0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7506fe0",
  null
  
)

export default component.exports